import { noop } from 'underscore';
import uuid from 'uuid-random';

import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import { AtpPopup } from './AtpPopup';

const popupId = uuid();

export const showAtpPopupAction = (props: { schedule: string; type: string; name: string }) =>
    addPopupAction({
        id: popupId,
        component: AtpPopup,
        layer: LAYER.COMMON,
        onClose: noop,
        closeAll: false,
        config: props
    });
